import React from 'react';
import { IncompleteApplicationsContainer } from '../containers/IncompleteApplicationsContainer';

export const IncompleteApplications = () => {
    return (
        <IncompleteApplicationsContainer />
    );
}